import React from 'react';
import PropTypes from 'prop-types';

export const IconOtherGames = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height="34"
    viewBox="0 0 44 43"
    fill="none"
  >
    <path d="M19.1589 0.330084C20.4065 0.46752 21.5486 1.09465 22.3341 2.07366C23.1196 3.05267 23.4843 4.30349 23.348 5.55125L21.7966 14.2683C21.6591 15.5159 21.032 16.6579 20.053 17.4434C19.074 18.2289 17.8232 18.5936 16.5754 18.4574L15.3605 18.3264C14.6648 18.2498 13.9948 18.0196 13.3989 17.6525C12.803 17.2854 12.2961 16.7906 11.9147 16.2037C11.5333 15.6169 11.2871 14.9527 11.1937 14.2591C11.1002 13.5654 11.162 12.8597 11.3746 12.1929L14.1184 3.5888C14.4527 2.54693 15.1376 1.65298 16.0565 1.05891C16.9753 0.464843 18.0716 0.207309 19.1589 0.330084Z" fill="url(#favorite_1)" />
    <path d="M31.6519 40.7896H15.8461C14.1553 40.7896 12.5338 40.1179 11.3382 38.9224C10.1426 37.7268 9.47095 36.1053 9.47095 34.4145V20.2482C9.47095 18.5574 10.1426 16.9359 11.3382 15.7403C12.5338 14.5447 14.1553 13.873 15.8461 13.873H37.6228C38.6722 13.8723 39.7056 14.1308 40.6312 14.6255C41.5567 15.1202 42.3457 15.8358 42.9282 16.7087C43.5107 17.5817 43.8686 18.5849 43.9701 19.6295C44.0717 20.674 43.9137 21.7274 43.5102 22.6962L37.5415 36.8624C37.0587 38.0265 36.2413 39.021 35.1929 39.7201C34.1444 40.4192 32.912 40.7914 31.6519 40.7896Z" fill="url(#favorite_2)" />
    <path d="M8.77346 11.8993H2.73253C2.00782 11.8993 1.31279 12.1872 0.80034 12.6996C0.287891 13.2121 0 13.9071 0 14.6318V40.0195C0 41.5281 1.22399 42.7521 2.73253 42.7521H8.77346C9.49817 42.7521 10.1932 42.4642 10.7057 41.9517C11.2181 41.4393 11.506 40.7442 11.506 40.0195V14.6318C11.506 13.9071 11.2181 13.2121 10.7057 12.6996C10.1932 12.1872 9.49817 11.8993 8.77346 11.8993Z" fill="url(#favorite_3)" />
  </svg>
);

IconOtherGames.propTypes = {
  className: PropTypes.string,
};

IconOtherGames.defaultProps = {
  className: '',
};
